export default __webpack_public_path__ + "12379f2a9026d54848e2362b45b2449b.svg";